import { useEffect, useState } from 'react';
import { isInIframe } from '../lib/utils';


const useInIframe = () => {
  const [inIframe, setInIframe] = useState(false);

  useEffect(() => {
    setInIframe(isInIframe());
  }, []);

  return inIframe;
}

export default useInIframe;